import { render, staticRenderFns } from "./aboutMsg.vue?vue&type=template&id=2c1c80ca&scoped=true"
import script from "./aboutMsg.vue?vue&type=script&lang=js"
export * from "./aboutMsg.vue?vue&type=script&lang=js"
import style0 from "./aboutMsg.vue?vue&type=style&index=0&id=2c1c80ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1c80ca",
  null
  
)

export default component.exports